import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Typography} from '~library/atoms/Typography';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';

export const Instructions = () => {
  const dispatch = useDispatch();
  const activeObject = window.canvas?.getActiveObject();
  const isFullDyo = useSelector(
    ({fabricTemplate}) =>
      fabricTemplate.templateName.includes('general-full') &&
      fabricTemplate.templateName.includes('dyo')
  );

  useEffect(() => {
    if (activeObject) {
      dispatch({type: UPDATE_DESIGN_OPTIONS, payload: {touched: true}});
    }

    return () => {
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {textAreaOpen: false},
      });
    };
  }, [activeObject]);

  const instructionText = isFullDyo
    ? 'Upload a photo to activate editing features'
    : 'Click the text on your invitation or upload a photo to activate editing features';

  return (
    <div className="welcome-instructions-container">
      <div className="edit_box welcome-instructions">
        <img
          className="welcome-instructions-img"
          src="/assets/images/step-1-instructions-img.png"
          alt=""
        />
        <Typography as="p" variant="paragraph2" size="medium" color="pebble">
          {instructionText}
        </Typography>
      </div>
    </div>
  );
};
